import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchAllAttendees, setAllAttendeesStatus } from '@/store/slices/audiences';
import {
  selectAllAttendeesFields,
  selectAllAttendeesPage,
  selectAllAttendeesPageSize,
  selectAllAttendeesSearch,
  selectAllAttendeesSort,
  selectAllAttendeesSortDirection,
  selectAllAttendeesStatus,
  selectAllAttendeesRegistrationFilter,
} from '@/store/slices/audiences/selectors';
import { selectWorkingProjectUuid } from '@/store/slices/project/selectors';
import { selectActiveChannel } from '@/store/slices/user/selectors';
import type { UserStatus } from '@/types/all-attendees.types';
import { useEffect } from 'react';

export const useLoadAllAttendeesList = (lockedStatus?: UserStatus) => {
  const dispatch = useAppDispatch();
  const channel = useAppSelector(selectActiveChannel);
  const eventUuid = useAppSelector(selectWorkingProjectUuid);
  const page = useAppSelector(selectAllAttendeesPage);
  const pageSize = useAppSelector(selectAllAttendeesPageSize);
  const search = useAppSelector(selectAllAttendeesSearch);
  const sort = useAppSelector(selectAllAttendeesSort);
  const sortDirection = useAppSelector(selectAllAttendeesSortDirection);
  const fields = useAppSelector(selectAllAttendeesFields);
  const status = useAppSelector(selectAllAttendeesStatus);
  const registrationStatusFilter = useAppSelector(selectAllAttendeesRegistrationFilter);

  // Sync lockedStatus into Redux first. React runs effects in declaration order,
  // so this fires before the fetch effect in the same flush, ensuring the store
  // reflects the correct status before fetchAllAttendees reads it.
  useEffect(() => {
    dispatch(setAllAttendeesStatus(lockedStatus));
  }, [lockedStatus, dispatch]);

  useEffect(() => {
    if (!eventUuid) return;
    dispatch(fetchAllAttendees(fields));
  }, [
    channel,
    eventUuid,
    page,
    pageSize,
    search,
    sort,
    sortDirection,
    fields,
    status,
    registrationStatusFilter,
    dispatch,
  ]);
};
